"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MonetaryAmountFieldset = class MonetaryAmountFieldset extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    updateValue(...args) {
        const [value] = args;
        const currentValue = this.item[this.path];
        this.item[this.path] = value;
        this.$emit("changed", value);
    }
    name;
    onName(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("name");
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    path;
    onPath(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("path");
    }
    defaultCurrency;
    onDefault_currency(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("defaultCurrency");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    currencies;
    async $$load_currencies() {
        return this.$app.repo.get('list_currency', { map: true, key: 'code' });
    }
    internalValue;
    async $$load_internalValue() {
        return _.extend({
            amount: null,
            currency: this.defaultCurrency,
        }, this.item[this.path]);
    }
    ux;
    dataMembers = ['currencies', 'internalValue', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                currencies: null,
                internalValue: null,
                ux: null,
            },
        };
    }
    get scale() {
        if (this.loaded) {
            return this.internalValue.currency ? this.currencies[this.internalValue.currency].digits : null;
        }
        return null;
    }
    get publicValue() {
        if (this.loaded) {
            return this.internalValue.currency && this.internalValue.amount != null ? this.internalValue : null;
        }
        return null;
    }
    async act_2248226175642056_script_4116_getActionArgs_value($event) {
        this.updateValue(this.publicValue);
    }
    async act_2248226175642056_script_4116_getActionArgs($event) {
        return {
            value: () => this.act_2248226175642056_script_4116_getActionArgs_value($event),
        };
    }
    async evh_2248226175642056_input(event, scope) {
        return await this.actions.evh_2248226175642056_input.executeFromDOM(this, event, scope);
    }
    async act_96700093353179_script_4118_getActionArgs_value($event) {
        this.updateValue(this.publicValue);
    }
    async act_96700093353179_script_4118_getActionArgs($event) {
        return {
            value: () => this.act_96700093353179_script_4118_getActionArgs_value($event),
        };
    }
    async evh_96700093353179_input(event, scope) {
        return await this.actions.evh_96700093353179_input.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_2248226175642056_script_4116 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2248226175642056_script_4116_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_input_4115 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_script_4116,
            event: "input",
            displayName: "script",
        });
        const evh_2248226175642056_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_input_4115],
        });
        const act_96700093353179_script_4118 = new core_1.actions.ScriptAction({
            actionArgs: this.act_96700093353179_script_4118_getActionArgs,
            events: [],
        });
        const evh_96700093353179_input_4117 = new core_1.actions.EventHandlerImpl({
            action: act_96700093353179_script_4118,
            event: "input",
            displayName: "script",
        });
        const evh_96700093353179_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_96700093353179_input_4117],
        });
        return {
            act_2248226175642056_script_4116,
            evh_2248226175642056_input_4115,
            evh_2248226175642056_input,
            act_96700093353179_script_4118,
            evh_96700093353179_input_4117,
            evh_96700093353179_input,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], MonetaryAmountFieldset.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('name'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MonetaryAmountFieldset.prototype, "onName", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], MonetaryAmountFieldset.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MonetaryAmountFieldset.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], MonetaryAmountFieldset.prototype, "path", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('path'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MonetaryAmountFieldset.prototype, "onPath", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], MonetaryAmountFieldset.prototype, "defaultCurrency", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('defaultCurrency'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MonetaryAmountFieldset.prototype, "onDefault_currency", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], MonetaryAmountFieldset.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MonetaryAmountFieldset.prototype, "onReadonly", null);
MonetaryAmountFieldset = __decorate([
    (0, vue_property_decorator_1.Component)()
], MonetaryAmountFieldset);
exports.default = MonetaryAmountFieldset;
vue_property_decorator_1.Vue.component("MonetaryAmountFieldset", MonetaryAmountFieldset);
